import { useRuntimeConfig } from '#imports';
import * as Sentry from '@sentry/nuxt';

const init = () => {
    const runtimeConfig = useRuntimeConfig();

    if (!runtimeConfig.public?.sentry?.dsn) {
        return;
    }

    // If you have a custom runtime config, you can use it here
    Sentry.init({
        dsn: runtimeConfig.public.sentry.dsn,
        environment: runtimeConfig.public.sentry.environment ?? 'client',
        replaysSessionSampleRate: 0.1,
        // allowUrls: [
        //     /https?:\/\/(preprod\.)?my\.skillsforwork\.(com|de)/,
        //     // px-learning
        //     /https?:\/\/static.(preprod\.)?px-learning.de/,
        //     /https?:\/\/(admin|app|api).(preprod\.)?px-learning.de/,
        // ],
        denyUrls: [
            /https:\/\/5f3c395\.ccm19\.de\/app\/public\/ccm19\.js/,
            /https:\/\/cdn\.helpspace\.com\/widget\/widget-v1\.js/,
            /https:\/\/user-frontend\.api\.pl-x\.cloud\/js\/widget\.js/,
        ],
        beforeSend: (event: Sentry.ErrorEvent, _hint: Sentry.EventHint) => {
            // Check for HTTP breadcrumbs with status 422
            const has422Breadcrumb = event.breadcrumbs?.some(
                (breadcrumb) =>
                    breadcrumb.category === 'http' &&
                    breadcrumb.data?.status === 422,
            );

            // Ignore events with 422 status
            if (has422Breadcrumb) {
                return null;
            }

            return event; // Send the error to Sentry for other status codes
        },
        integrations: [
            Sentry.thirdPartyErrorFilterIntegration({
                // Specify the application keys that you specified in the Sentry bundler plugin
                filterKeys: ['px-teach-frontend', 'px-learning-player'],

                // Defines how to handle errors that contain third party stack frames.
                // Possible values are:
                // - 'drop-error-if-contains-third-party-frames'
                // - 'drop-error-if-exclusively-contains-third-party-frames'
                // - 'apply-tag-if-contains-third-party-frames'
                // - 'apply-tag-if-exclusively-contains-third-party-frames'
                behaviour: 'apply-tag-if-contains-third-party-frames',
            }),
        ],
    });

    // try {
    //     const { user, loggedIn } = useUserSession();

    //     // Set user context
    //     if (loggedIn.value) {
    //         Sentry.setUser({
    //             // @ts-expect-error - The user object is not typed in the Sentry SDK
    //             id: user.value?.uuid,
    //             // @ts-expect-error - The user object is not typed in the Sentry SDK
    //             email: user.value?.email,
    //             // @ts-expect-error - The user object is not typed in the Sentry SDK
    //             username: user.value?.username,
    //         });
    //     }
    // } catch (error) {
    //     Sentry.setUser(null);
    // }
};

init();
